import UserProfileDetails from './UserProfileDetails';

export default UserProfileDetails;
